import styles from './Message.module.css';
import lightningRight from '../../assets/images/lightningRight.png';
import lightningLeft from '../../assets/images/lightningLeft.png';

const Message = ({
  message,
  titrTag,
  phoneNumberFontSize,
  authorFontSize,
  msgFontSize,
  win,
  currentState,
  winId,
  winIds,
  msgDataField,
}) => {
  const isWinner = winId === message.id && currentState === 'S4';
  const msgField = message?.hasOwnProperty(msgDataField)
    ? msgDataField
    : 'author';

  return (
    <div className={styles['wrapper']}>
      {message && (
        <div className={`${styles['blockMsg']}`}>
          <div
            className={`${styles['nameAuthor']} ${
              isWinner && styles['winnerBg']
            }`}>
            <div className={styles['text']}>{message?.[msgField].trim()}</div>
            {isWinner && (
              <>
                <div className={`${styles.lightning} ${styles.left}`}>
                  <img src={lightningLeft} alt="lightningLeft" />
                </div>
                <div className={`${styles.lightning} ${styles.right}`}>
                  <img src={lightningRight} alt="lightningRight" />
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Message;
